import jQuery from 'jquery';

(function ($) {
  console.log('$:', $);
  $(document).ready(function () {
    $('.ins_ft-button').on('click', function (e) {
      $(this)
        .toggleClass('active')
        .next('.ins_ft-list')
        .slideToggle({
          start: function () {
            $(this).css({
              display: 'flex',
            });
          },
        });
    });
  });
})(jQuery);
